import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model, OptionModel } from "../model";
import { JobTitleCompetenceLevelType } from "services/enums/jobTitleCompetenceLevelType.enum";

export class JobTitleCompetenceLevelModel
  extends Model
  implements IModel<JobTitleCompetenceLevelModel> {
  title: string = "";
  companyGroupId: string | undefined = undefined;
  type: number = JobTitleCompetenceLevelType.NotDefined.id;

  static create(input: any): JobTitleCompetenceLevelModel {
    return ObjectMapper.deserialize<JobTitleCompetenceLevelModel>(
      JobTitleCompetenceLevelModel,
      input
    );
  }

  toOption(): OptionModel {
    return { label: `${this.title}`, value: this.id } as OptionModel;
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}